var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"5px"}},[(
      _vm.resultList &&
        _vm.resultList.length > 0 &&
        _vm.resultList[0].CONTENTLIST &&
        _vm.resultList[0].CONTENTLIST.length > 0 &&
        _vm.resultList[0].CONTENTLIST[0].DATALIST &&
        _vm.resultList[0].CONTENTLIST[0].DATALIST.length > 0
    )?_c('div',[(_vm.resultList && _vm.resultList.length > 0)?_c('div',{staticStyle:{"text-align":"center","padding":"8px","background":"#6f6f6f","color":"#fff"}},[_c('h4',{staticStyle:{"margin":"5px"}},[_vm._v("\n        "+_vm._s(_vm.resultList[0].CONTENTLIST[0].DATALIST[0].XMQC +
            "(" +
            _vm.resultList[0].CONTENTLIST[0].DATALIST[0].XMJC +
            ")")+_vm._s(_vm.queryType === "ZXC" ? "秩序册" : "成绩册")+"\n      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.resultList),function(mainItem,mainIndex){return _c('div',{key:mainIndex},[(mainItem.CONTENTLIST.length > 0)?_c('div',{staticClass:"topMainDivClass",style:({
          height: mainItem.CONTENTLIST[0].DATALIST.length * 90 + 'px'
        })},[_c('h3',{staticStyle:{"text-align":"center","position":"relative","top":"-66px"}},[_vm._m(0,true),_vm._v("\n          "+_vm._s(mainItem.BJW)+"\n        ")]),_vm._v(" "),(mainItem.CONTENTLIST[0].DATALIST.length > 0)?_c('div',{staticStyle:{"float":"left"}},_vm._l((mainItem.CONTENTLIST[0].DATALIST),function(item,index){return _c('div',{key:index,staticClass:"divMain1",style:({
              position: 'absolute',
              top: index * (60 + 30) + 'px'
            })},[_c('span',{staticClass:"titleSpan1"},[_c('van-badge',{attrs:{"content":item.ZNWZH1.replace('(0)', ''),"color":"#1989fa"}}),_vm._v("\n               "+_vm._s(item.ZNWZH1.indexOf("(0)") > -1
                  ? "轮空"
                  : item.RYXM1.length === 0
                  ? item.MCZH1.replace("-", "组第")
                  : item.RYXM1 +
                    (item.SSLX.substr(1, 2) === "T"
                      ? ""
                      : "(" + item.DWJC1 + ")"))+"\n            ")],1),_vm._v(" "),_c('span',{staticClass:"titleSpan2"},[_c('van-badge',{attrs:{"content":item.ZNWZH2.replace('(0)', ''),"color":"#1989fa"}}),_vm._v(" \n              "+_vm._s(item.ZNWZH2.indexOf("(0)") > -1
                  ? "轮空"
                  : item.RYXM2.length === 0
                  ? item.MCZH2.replace("-", "组第")
                  : item.RYXM2 +
                    (item.SSLX.substr(1, 2) === "T"
                      ? ""
                      : "(" + item.DWJC2 + ")"))+"\n            ")],1),_vm._v(" "),(_vm.queryType === 'ZXC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileTopRight"},[_vm._v("\n                "+_vm._s(item.RQ.length > 6 ? item.RQ.substr(5, 9) : "")+"\n\n                "+_vm._s(item.STARTTIME.length === 0 || item.STARTTIME === "-"
                    ? item.CXH.length > 0
                      ? "场序:" + item.CXH
                      : ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red"}}):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red"}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.queryType === 'CJC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[_c('span',{staticClass:"spanTitileTopRight",style:({
                  color:
                    item.BSZT === '-1'
                      ? item.ZNWZH1.indexOf('(0)') > -1 ||
                        item.ZNWZH2.indexOf('(0)') > -1
                        ? 'green'
                        : 'black'
                      : item.BSZT === '0'
                      ? 'blue'
                      : 'green'
                })},[_vm._v("\n                "+_vm._s(item.BSZT === "-1"
                    ? item.ZNWZH1.indexOf("(0)") > -1 ||
                      item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1.indexOf("(0)") > -1 &&
                        item.ZNWZH2.indexOf("(0)") === -1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.ZNWZH1.indexOf("(0)") === -1 &&
                          item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : ""
                      : "未开赛"
                    : item.BSZT === "0"
                    ? "比赛中"
                    : item.ISPF1 === "0" && item.ISPF2 === "1"
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.ISPF1 === "1" && item.ISPF2 === "0"
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                      (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                    ? "双弃权"
                    : item.ZNWZH1.indexOf("(0)") > -1
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : item.ZNWZH2.indexOf("(0)") > -1
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 > item.MARK2
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 === item.MARK2
                    ? item.SC1 > item.SC2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.SC2 > item.SC1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.MARK1 > 0 || item.MARK2 > 0
                      ? "比赛中"
                      : "未开赛"
                    : item.ZNWZH2 + "  " + item.RYXM2)+"\n              ")]),_vm._v(" "),(item.SSLX.substr(1, 2) === 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s((item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                      ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                      : "") +
                      item.MARK1 +
                      ":" +
                      item.MARK2 +
                      (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""))+"\n                  "+_vm._s(item.SSLX.substr(1, 2) === "T"
                      ? ""
                      : item.MARK1 > 0 &&
                        item.MARK2 > 0 &&
                        item.MARK1 === item.MARK2
                      ? "(" + item.SC1 + ":" + item.SC2 + ")"
                      : "")+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) !== 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF1 === "1" ||
                        item.CJMXLIST[0].ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                  "),_vm._l((item.CJMXLIST),function(cjMxItem,cjMxIndex){return _c('label',{key:cjMxIndex},[_vm._v("\n                    "+_vm._s(+cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  ")+"\n                  ")])}),_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF2 === "1" ||
                        item.CJMXLIST[0].ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                ")],2):_vm._e()]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(item.RQ)+" "+_vm._s(item.STARTTIME === "-" || item.STARTTIME.length === 0
                    ? ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e()]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(
            mainItem.CONTENTLIST[1] !== undefined &&
              mainItem.CONTENTLIST[1].DATALIST.length > 0
          )?_c('div',{staticStyle:{"float":"left"}},_vm._l((mainItem.CONTENTLIST[1].DATALIST),function(item,index){return _c('div',{key:index,staticClass:"divMain2",style:({
              position: 'absolute',
              top: index * (60 + 30) * 2 + 31 + 'px'
            })},[(_vm.queryType === 'ZXC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileTopRight"},[_vm._v("\n                "+_vm._s(item.RQ.length > 6 ? item.RQ.substr(5, 9) : "")+"\n                 \n                "+_vm._s(item.STARTTIME.length === 0 || item.STARTTIME === "-"
                    ? item.CXH.length > 0
                      ? "场序:" + item.CXH
                      : ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red"}}):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red"}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.queryType === 'CJC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[_c('span',{staticClass:"spanTitileTopRight",style:({
                  color:
                    item.BSZT === '-1'
                      ? item.ZNWZH1.indexOf('(0)') > -1 ||
                        item.ZNWZH2.indexOf('(0)') > -1
                        ? 'green'
                        : 'black'
                      : item.BSZT === '0'
                      ? 'blue'
                      : 'green'
                })},[_vm._v("\n                "+_vm._s(item.BSZT === "-1"
                    ? item.ZNWZH1.indexOf("(0)") > -1 ||
                      item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1.indexOf("(0)") > -1 &&
                        item.ZNWZH2.indexOf("(0)") === -1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.ZNWZH1.indexOf("(0)") === -1 &&
                          item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : ""
                      : "未开赛"
                    : item.BSZT === "0"
                    ? "比赛中"
                    : item.ISPF1 === "0" && item.ISPF2 === "1"
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.ISPF1 === "1" && item.ISPF2 === "0"
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                      (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                    ? "双弃权"
                    : item.ZNWZH1.indexOf("(0)") > -1
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : item.ZNWZH2.indexOf("(0)") > -1
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 > item.MARK2
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 === item.MARK2
                    ? item.SC1 > item.SC2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.SC2 > item.SC1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.MARK1 > 0 || item.MARK2 > 0
                      ? "比赛中"
                      : "未开赛"
                    : item.ZNWZH2 + "  " + item.RYXM2)+"\n              ")]),_vm._v(" "),(item.SSLX.substr(1, 2) === 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s((item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                      ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                      : "") +
                      item.MARK1 +
                      ":" +
                      item.MARK2 +
                      (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""))+"\n                  "+_vm._s(item.SSLX.substr(1, 2) === "T"
                      ? ""
                      : item.MARK1 > 0 &&
                        item.MARK2 > 0 &&
                        item.MARK1 === item.MARK2
                      ? "(" + item.SC1 + ":" + item.SC2 + ")"
                      : "")+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) !== 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF1 === "1" ||
                        item.CJMXLIST[0].ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                  "),_vm._l((item.CJMXLIST),function(cjMxItem,cjMxIndex){return _c('label',{key:cjMxIndex},[_vm._v("\n                    "+_vm._s(+cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  ")+"\n                  ")])}),_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF2 === "1" ||
                        item.CJMXLIST[0].ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                ")],2):_vm._e()]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(item.RQ)+" "+_vm._s(item.STARTTIME === "-" || item.STARTTIME.length === 0
                    ? ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e()]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(
            mainItem.CONTENTLIST[2] !== undefined &&
              mainItem.CONTENTLIST[2].DATALIST.length > 0
          )?_c('div',{staticStyle:{"float":"left"}},_vm._l((mainItem.CONTENTLIST[2].DATALIST),function(item,index){return _c('div',{key:index,staticClass:"divMain3",style:({
              position: 'absolute',
              top: index * (60 + 30) * 2 * 2 + (60 + 16) + 'px'
            })},[(_vm.queryType === 'ZXC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileTopRight",staticStyle:{"top":"35%"}},[_vm._v("\n                "+_vm._s(item.RQ.length > 6 ? item.RQ.substr(5, 9) : "")+"\n                 \n                "+_vm._s(item.STARTTIME.length === 0 || item.STARTTIME === "-"
                    ? item.CXH.length > 0
                      ? "场序:" + item.CXH
                      : ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red"}}):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red"}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.queryType === 'CJC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[_c('span',{staticClass:"spanTitileTopRight",style:({
                  color:
                    item.BSZT === '-1'
                      ? item.ZNWZH1.indexOf('(0)') > -1 ||
                        item.ZNWZH2.indexOf('(0)') > -1
                        ? 'green'
                        : 'black'
                      : item.BSZT === '0'
                      ? 'blue'
                      : 'green',
                  top: '37%'
                })},[_vm._v("\n                "+_vm._s(item.BSZT === "-1"
                    ? item.ZNWZH1.indexOf("(0)") > -1 ||
                      item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1.indexOf("(0)") > -1 &&
                        item.ZNWZH2.indexOf("(0)") === -1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.ZNWZH1.indexOf("(0)") === -1 &&
                          item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : ""
                      : "未开赛"
                    : item.BSZT === "0"
                    ? "比赛中"
                    : item.ISPF1 === "0" && item.ISPF2 === "1"
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.ISPF1 === "1" && item.ISPF2 === "0"
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                      (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                    ? "双弃权"
                    : item.ZNWZH1.indexOf("(0)") > -1
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : item.ZNWZH2.indexOf("(0)") > -1
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 > item.MARK2
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 === item.MARK2
                    ? item.SC1 > item.SC2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.SC2 > item.SC1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.MARK1 > 0 || item.MARK2 > 0
                      ? "比赛中"
                      : "未开赛"
                    : item.ZNWZH2 + "  " + item.RYXM2)+"\n              ")]),_vm._v(" "),(item.SSLX.substr(1, 2) === 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s((item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                      ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                      : "") +
                      item.MARK1 +
                      ":" +
                      item.MARK2 +
                      (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""))+"\n                  "+_vm._s(item.SSLX.substr(1, 2) === "T"
                      ? ""
                      : item.MARK1 > 0 &&
                        item.MARK2 > 0 &&
                        item.MARK1 === item.MARK2
                      ? "(" + item.SC1 + ":" + item.SC2 + ")"
                      : "")+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) !== 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF1 === "1" ||
                        item.CJMXLIST[0].ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                  "),_vm._l((item.CJMXLIST),function(cjMxItem,cjMxIndex){return _c('label',{key:cjMxIndex},[_vm._v("\n                    "+_vm._s(+cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  ")+"\n                  ")])}),_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF2 === "1" ||
                        item.CJMXLIST[0].ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                ")],2):_vm._e()]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red","top":"33%"}},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red","top":"43%"}},[_vm._v("\n                "+_vm._s(item.RQ)+" "+_vm._s(item.STARTTIME === "-" || item.STARTTIME.length === 0
                    ? ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red","top":"52%"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e()]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(
            mainItem.CONTENTLIST[3] !== undefined &&
              mainItem.CONTENTLIST[3].DATALIST.length > 0
          )?_c('div',{staticStyle:{"float":"left"}},_vm._l((mainItem.CONTENTLIST[3].DATALIST),function(item,index){return _c('div',{key:index,staticClass:"divMain4",style:({
              position: 'absolute',
              top: index * (60 + 30) * 2 * 2 * 2 + ((60 + 16) * 2 + 15) + 'px'
            })},[(_vm.queryType === 'ZXC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileTopRight",staticStyle:{"top":"45%"}},[_vm._v("\n                "+_vm._s(item.RQ.length > 6 ? item.RQ.substr(5, 9) : "")+"\n                 \n                "+_vm._s(item.STARTTIME.length === 0 || item.STARTTIME === "-"
                    ? item.CXH.length > 0
                      ? "场序:" + item.CXH
                      : ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red"}}):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red","top":"46%"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red"}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.queryType === 'CJC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileTopRight",style:({
                  color:
                    item.BSZT === '-1'
                      ? item.ZNWZH1.indexOf('(0)') > -1 ||
                        item.ZNWZH2.indexOf('(0)') > -1
                        ? 'green'
                        : 'black'
                      : item.BSZT === '0'
                      ? 'blue'
                      : 'green',
                  top: '43%'
                })},[_vm._v("\n                "+_vm._s(item.BSZT === "-1"
                    ? item.ZNWZH1.indexOf("(0)") > -1 ||
                      item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1.indexOf("(0)") > -1 &&
                        item.ZNWZH2.indexOf("(0)") === -1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.ZNWZH1.indexOf("(0)") === -1 &&
                          item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : ""
                      : "未开赛"
                    : item.BSZT === "0"
                    ? "比赛中"
                    : item.ISPF1 === "0" && item.ISPF2 === "1"
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.ISPF1 === "1" && item.ISPF2 === "0"
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                      (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                    ? "双弃权"
                    : item.ZNWZH1.indexOf("(0)") > -1
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : item.ZNWZH2.indexOf("(0)") > -1
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 > item.MARK2
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 === item.MARK2
                    ? item.SC1 > item.SC2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.SC2 > item.SC1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.MARK1 > 0 || item.MARK2 > 0
                      ? "比赛中"
                      : "未开赛"
                    : item.ZNWZH2 + "  " + item.RYXM2)+"\n              ")]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) === 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s((item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                      ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                      : "") +
                      item.MARK1 +
                      ":" +
                      item.MARK2 +
                      (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""))+"\n                  "+_vm._s(item.SSLX.substr(1, 2) === "T"
                      ? ""
                      : item.MARK1 > 0 &&
                        item.MARK2 > 0 &&
                        item.MARK1 === item.MARK2
                      ? "(" + item.SC1 + ":" + item.SC2 + ")"
                      : "")+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) !== 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF1 === "1" ||
                        item.CJMXLIST[0].ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                  "),_vm._l((item.CJMXLIST),function(cjMxItem,cjMxIndex){return _c('label',{key:cjMxIndex},[_vm._v("\n                    "+_vm._s(+cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  ")+"\n                  ")])}),_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF2 === "1" ||
                        item.CJMXLIST[0].ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                ")],2):_vm._e()]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red","top":"41%"}},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red","top":"46%"}},[_vm._v("\n                "+_vm._s(item.RQ)+" "+_vm._s(item.STARTTIME === "-" || item.STARTTIME.length === 0
                    ? ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red","top":"50%"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e()]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(
            mainItem.CONTENTLIST[4] !== undefined &&
              mainItem.CONTENTLIST[4].DATALIST.length > 0
          )?_c('div',{staticStyle:{"float":"left"}},_vm._l((mainItem.CONTENTLIST[4].DATALIST),function(item,index){return _c('div',{key:index,staticClass:"divMain5",style:({
              position: 'absolute',
              top:
                index * (60 + 30) * 2 * 2 * 2 * 2 +
                ((60 + 15) * 2 * 2 + 15 * 2) +
                16 +
                'px'
            })},[(_vm.queryType === 'ZXC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileTopRight",staticStyle:{"top":"44%"}},[_vm._v("\n                "+_vm._s(item.RQ.length > 6 ? item.RQ.substr(5, 9) : "")+"\n                 \n                "+_vm._s(item.STARTTIME.length === 0 || item.STARTTIME === "-"
                    ? item.CXH.length > 0
                      ? "场序:" + item.CXH
                      : ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileBottomRight",staticStyle:{"top":"52%"}},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red"}}):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red","top":"49%"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red"}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.queryType === 'CJC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileTopRight",style:({
                  color:
                    item.BSZT === '-1'
                      ? item.ZNWZH1.indexOf('(0)') > -1 ||
                        item.ZNWZH2.indexOf('(0)') > -1
                        ? 'green'
                        : 'black'
                      : item.BSZT === '0'
                      ? 'blue'
                      : 'green',
                  top: '44%'
                })},[_vm._v("\n                "+_vm._s(item.BSZT === "-1"
                    ? item.ZNWZH1.indexOf("(0)") > -1 ||
                      item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1.indexOf("(0)") > -1 &&
                        item.ZNWZH2.indexOf("(0)") === -1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.ZNWZH1.indexOf("(0)") === -1 &&
                          item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : ""
                      : "未开赛"
                    : item.BSZT === "0"
                    ? "比赛中"
                    : item.ISPF1 === "0" && item.ISPF2 === "1"
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.ISPF1 === "1" && item.ISPF2 === "0"
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                      (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                    ? "双弃权"
                    : item.ZNWZH1.indexOf("(0)") > -1
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : item.ZNWZH2.indexOf("(0)") > -1
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 > item.MARK2
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 === item.MARK2
                    ? item.SC1 > item.SC2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.SC2 > item.SC1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.MARK1 > 0 || item.MARK2 > 0
                      ? "比赛中"
                      : "未开赛"
                    : item.ZNWZH2 + "  " + item.RYXM2)+"\n              ")]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) === 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s((item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                      ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                      : "") +
                      item.MARK1 +
                      ":" +
                      item.MARK2 +
                      (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""))+"\n                  "+_vm._s(item.SSLX.substr(1, 2) === "T"
                      ? ""
                      : item.MARK1 > 0 &&
                        item.MARK2 > 0 &&
                        item.MARK1 === item.MARK2
                      ? "(" + item.SC1 + ":" + item.SC2 + ")"
                      : "")+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) !== 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF1 === "1" ||
                        item.CJMXLIST[0].ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                  "),_vm._l((item.CJMXLIST),function(cjMxItem,cjMxIndex){return _c('label',{key:cjMxIndex},[_vm._v("\n                    "+_vm._s(+cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  ")+"\n                  ")])}),_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF2 === "1" ||
                        item.CJMXLIST[0].ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                ")],2):_vm._e()]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red","top":"45%"}},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red","top":"49%"}},[_vm._v("\n                "+_vm._s(item.RQ)+" "+_vm._s(item.STARTTIME === "-" || item.STARTTIME.length === 0
                    ? ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red","top":"52%"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e()]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(
            mainItem.CONTENTLIST[5] !== undefined &&
              mainItem.CONTENTLIST[5].DATALIST.length > 0
          )?_c('div',{staticStyle:{"float":"left"}},_vm._l((mainItem.CONTENTLIST[5].DATALIST),function(item,index){return _c('div',{key:index,staticClass:"divMain6",style:({
              position: 'absolute',
              top:
                index * (60 + 30) * 2 * 2 * 2 * 2 * 2 +
                ((60 + 15) * 2 * 2 * 2 + 15 * 2 + 77) +
                'px'
            })},[(_vm.queryType === 'ZXC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileTopRight",staticStyle:{"top":"46%"}},[_vm._v("\n                "+_vm._s(item.RQ.length > 6 ? item.RQ.substr(5, 9) : "")+"\n                 \n                "+_vm._s(item.STARTTIME.length === 0 || item.STARTTIME === "-"
                    ? item.CXH.length > 0
                      ? "场序:" + item.CXH
                      : ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red"}}):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red","top":"49%"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red"}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.queryType === 'CJC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileTopRight",style:({
                  color:
                    item.BSZT === '-1'
                      ? item.ZNWZH1.indexOf('(0)') > -1 ||
                        item.ZNWZH2.indexOf('(0)') > -1
                        ? 'green'
                        : 'black'
                      : item.BSZT === '0'
                      ? 'blue'
                      : 'green',
                  top: '46%'
                })},[_vm._v("\n                "+_vm._s(item.BSZT === "-1"
                    ? item.ZNWZH1.indexOf("(0)") > -1 ||
                      item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1.indexOf("(0)") > -1 &&
                        item.ZNWZH2.indexOf("(0)") === -1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.ZNWZH1.indexOf("(0)") === -1 &&
                          item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : ""
                      : "未开赛"
                    : item.BSZT === "0"
                    ? "比赛中"
                    : item.ISPF1 === "0" && item.ISPF2 === "1"
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.ISPF1 === "1" && item.ISPF2 === "0"
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                      (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                    ? "双弃权"
                    : item.ZNWZH1.indexOf("(0)") > -1
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : item.ZNWZH2.indexOf("(0)") > -1
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 > item.MARK2
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 === item.MARK2
                    ? item.SC1 > item.SC2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.SC2 > item.SC1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.MARK1 > 0 || item.MARK2 > 0
                      ? "比赛中"
                      : "未开赛"
                    : item.ZNWZH2 + "  " + item.RYXM2)+"\n              ")]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) === 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s((item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                      ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                      : "") +
                      item.MARK1 +
                      ":" +
                      item.MARK2 +
                      (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""))+"\n                  "+_vm._s(item.SSLX.substr(1, 2) === "T"
                      ? ""
                      : item.MARK1 > 0 &&
                        item.MARK2 > 0 &&
                        item.MARK1 === item.MARK2
                      ? "(" + item.SC1 + ":" + item.SC2 + ")"
                      : "")+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) !== 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight"},[_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF1 === "1" ||
                        item.CJMXLIST[0].ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                  "),_vm._l((item.CJMXLIST),function(cjMxItem,cjMxIndex){return _c('label',{key:cjMxIndex},[_vm._v("\n                    "+_vm._s(+cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  ")+"\n                  ")])}),_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF2 === "1" ||
                        item.CJMXLIST[0].ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                ")],2):_vm._e()]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red","top":"46%"}},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red","top":"49%"}},[_vm._v("\n                "+_vm._s(item.RQ)+" "+_vm._s(item.STARTTIME === "-" || item.STARTTIME.length === 0
                    ? ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red","top":"53%"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e()]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(
            mainItem.CONTENTLIST[6] !== undefined &&
              mainItem.CONTENTLIST[6].DATALIST.length > 0
          )?_c('div',{staticStyle:{"float":"left"}},_vm._l((mainItem.CONTENTLIST[6].DATALIST),function(item,index){return _c('div',{key:index,staticClass:"divMain7",style:({
              position: 'absolute',
              top:
                index * (60 + 30) * 2 * 2 * 2 * 2 * 2 +
                ((60 + 15) * 2 * 2 * 2 * 2 + 15 * 2 + 77 * 2) +
                43 +
                'px'
            })},[(_vm.queryType === 'ZXC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileTopRight",staticStyle:{"top":"49%"}},[_vm._v("\n                "+_vm._s(item.RQ.length > 6 ? item.RQ.substr(5, 9) : "")+"\n                 \n                "+_vm._s(item.STARTTIME.length === 0 || item.STARTTIME === "-"
                    ? item.CXH.length > 0
                      ? "场序:" + item.CXH
                      : ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1 &&
                    _vm.queryType === 'ZXC'
                )?_c('span',{staticClass:"spanTitileBottomRight",staticStyle:{"top":"51%"}},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red"}}):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red","top":"50%"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red"}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.queryType === 'CJC')?_c('div',{on:{"click":function($event){return _vm.jumpMxHandler(item.CCH)}}},[(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileTopRight",style:({
                  color:
                    item.BSZT === '-1'
                      ? item.ZNWZH1.indexOf('(0)') > -1 ||
                        item.ZNWZH2.indexOf('(0)') > -1
                        ? 'green'
                        : 'black'
                      : item.BSZT === '0'
                      ? 'blue'
                      : 'green',
                  top: '49%'
                })},[_vm._v("\n                "+_vm._s(item.BSZT === "-1"
                    ? item.ZNWZH1.indexOf("(0)") > -1 ||
                      item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1.indexOf("(0)") > -1 &&
                        item.ZNWZH2.indexOf("(0)") === -1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.ZNWZH1.indexOf("(0)") === -1 &&
                          item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : ""
                      : "未开赛"
                    : item.BSZT === "0"
                    ? "比赛中"
                    : item.ISPF1 === "0" && item.ISPF2 === "1"
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.ISPF1 === "1" && item.ISPF2 === "0"
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                      (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                    ? "双弃权"
                    : item.ZNWZH1.indexOf("(0)") > -1
                    ? item.ZNWZH2 + "  " + item.RYXM2
                    : item.ZNWZH2.indexOf("(0)") > -1
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 > item.MARK2
                    ? item.ZNWZH1 + "  " + item.RYXM1
                    : item.MARK1 === item.MARK2
                    ? item.SC1 > item.SC2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.SC2 > item.SC1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.MARK1 > 0 || item.MARK2 > 0
                      ? "比赛中"
                      : "未开赛"
                    : item.ZNWZH2 + "  " + item.RYXM2)+"\n              ")]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) === 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight",staticStyle:{"top":"51%"}},[_vm._v("\n                  "+_vm._s((item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                      ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                      : "") +
                      item.MARK1 +
                      ":" +
                      item.MARK2 +
                      (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""))+"\n                  "+_vm._s(item.SSLX.substr(1, 2) === "T"
                      ? ""
                      : item.MARK1 > 0 &&
                        item.MARK2 > 0 &&
                        item.MARK1 === item.MARK2
                      ? "(" + item.SC1 + ":" + item.SC2 + ")"
                      : "")+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.SSLX.substr(1, 2) !== 'T')?_c('label',[(
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  )?_c('span',{staticClass:"spanTitileBottomRight",staticStyle:{"top":"51%"}},[_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF1 === "1" ||
                        item.CJMXLIST[0].ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                  "),_vm._l((item.CJMXLIST),function(cjMxItem,cjMxIndex){return _c('label',{key:cjMxIndex},[_vm._v("\n                    "+_vm._s(+cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  ")+"\n                  ")])}),_vm._v("\n                  "+_vm._s(item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                      ? item.CJMXLIST[0].ISPF2 === "1" ||
                        item.CJMXLIST[0].ISDCQQ2 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : ""
                      : "")+"\n                ")],2):_vm._e()]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft1",staticStyle:{"color":"red","top":"49%"}},[_vm._v("\n                "+_vm._s(item.CDH.length > 0 ? item.CDH + "号场地" : "")+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft2",staticStyle:{"color":"red","top":"50%"}},[_vm._v("\n                "+_vm._s(item.RQ)+" "+_vm._s(item.STARTTIME === "-" || item.STARTTIME.length === 0
                    ? ""
                    : item.STARTTIME)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  item.ZNWZH1.indexOf('(0)') === -1 &&
                    item.ZNWZH2.indexOf('(0)') === -1
                )?_c('span',{staticClass:"spanTitileBottomLeft3",staticStyle:{"color":"red","top":"51%"}},[_vm._v("\n                "+_vm._s(item.SSLXMC)+"\n                ")]):_vm._e()]):_vm._e()])}),0):_vm._e()]):_vm._e()])})],2):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{staticStyle:{"width":"25px"},attrs:{"src":"https://www.ptty.com.cn/wap/jb.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4db0e70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commonCom/TtsViewCom.vue
// module id = null
// module chunks = 